import { Guide } from "./Guide";
import { GuidesProvider } from "./Guide/use-guide";

export default function PipelineEditorSidebar({
  trackingContext,
}: {
  trackingContext: {
    organizationUuid: string;
  };
}) {
  return (
    <GuidesProvider trackingContext={trackingContext}>
      <Guide />
    </GuidesProvider>
  );
}
